import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {HubPageService_StreamLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/hub_page/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useStaleLastSeenProductIds} from '../../../features/LastSeenProducts/useLastSeenProductIds';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
// eslint-disable-next-line jest/no-mocks-import
import {useHubTypeFromSlug} from './useHubTypeFromSlug';

export const useHubPageStream = () => {
  return useHubPageStreamBase({token: null});
};

export const useHubPageStreamNext = ({token}: {token: string}) => {
  return useHubPageStreamBase({token});
};

const useHubPageStreamBase = ({token}: {token: string | null}) => {
  const session = useFullSession();
  const targetGroup = useTargetGroupIdentifier();
  const hubType = useHubTypeFromSlug();
  const lastSeenProductIds = useStaleLastSeenProductIds({
    uniqueKey: `${hubType}_LAST_SEEN_PRODUCT_IDS`,
  });

  const request = useGrpcRequest(
    HubPageService_StreamLazy,
    {
      session: !token ? null : session,
      targetGroup,
      hub: hubType,
      limit: !token ? 1 : 5,
      continuationToken: token,
      reductionsState: useReductionsStateRequestParameter(),
      lastSeenProductIds,
    },
    {
      keepPreviousData: true,
      disabled: process.browser && !session,
    },
  );

  const nextState =
    request.data?.items[request.data?.items.length - 1]?.continuationToken;

  return {
    ...request,
    data: request.data
      ? {
          ...request.data,
          nextState,
        }
      : undefined,
  };
};
